import {
  UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING,
  UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_FAILED,
  UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_SUCCEEDED,
} from 'Redux/Types/AccountSettingsTypes'

const INITIAL_STATE = {
  sendForHumanReview: false,
  docTypeId: null,
  needsReview: 0,
  companyId: null,
  loading: false,
  settingUpdated: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  //console.log("🚀 ~ payload:", payload)
  switch (type) {
    case UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING:
      return {
        ...state,
        loading: true,
        settingUpdated: false,
      }
    case UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_FAILED:
      return {
        ...state,
        loading: false,
        settingUpdated: false,
      }
    case UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_SUCCEEDED:
      return {
        ...state,
        sendForHumanReview: payload.sendForHumanReview,
        docTypeId: payload.docTypeId,
        needsReview: payload.needsReview,
        companyId: payload.companyId,
        loading: false,
        settingUpdated: true,
      }

    default:
      return state
  }
}
